import React from 'react';

import { BuildVuPage } from '../api';
import { Attachment } from '../Attachment';
import { Page } from '../Page';
import { GateOverlay } from './GateOverlay';
import { RelatedPapers } from '../interstitials/RelatedPapers';
import { RelatedPaper } from '../interstitials/types';

type GatedAttachmentVariant = 'blur_page_2' | 'blur_33_percent';

export type GatedAttachmentProps = {
  attachmentId: string;
  firstPageUrl?: string;
  totalPages: number;
  universityCount: number;
  variant: GatedAttachmentVariant;
  className?: string;
  relatedPapers?: RelatedPaper[];
};

const calculateVisiblePages = (
  variant: GatedAttachmentVariant,
  totalPages: number,
): number => {
  if (variant === 'blur_page_2') return 1;
  return Math.max(1, Math.floor(totalPages * 0.33));
};

export const GatedAttachment: React.FC<GatedAttachmentProps> = ({
  attachmentId,
  firstPageUrl,
  totalPages,
  universityCount,
  variant,
  className,
  relatedPapers = [],
}) => {
  const visiblePages = calculateVisiblePages(variant, totalPages);
  const blurredPageNumber = visiblePages + 1;
  const blurredPage: BuildVuPage | null = firstPageUrl
    ? {
        page_url: firstPageUrl.replace(
          /\/\d+\.html$/,
          `/${blurredPageNumber}.html`,
        ),
        page_number: blurredPageNumber,
        width: 850,
        height: 1100,
      }
    : null;

  return (
    <div className={className}>
      <Attachment
        attachmentId={attachmentId}
        firstPageUrl={firstPageUrl}
        pages={visiblePages}
        shown={true}
      />
      {blurredPage && (
        <>
          <div className="gated-attachment__blurred-page">
            <Page page={blurredPage} load={true} onIntersect={() => {}} />
          </div>
          <GateOverlay universityCount={universityCount} />
        </>
      )}
      <RelatedPapers papers={relatedPapers} />
    </div>
  );
};
